<!-- eslint-disable -->
<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body(action='javascript://', v-if='params')
            slot(v-if="slug === 'InteractiveFlashCards'", name='multiplayer')
            template(v-if='!homework || homework.editable === undefined || (homework && (homework.editable || usersIds))')
                template(v-if="gameMode !== 'course'")
                    .form__field
                        label.form__label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_showTimeNumbers') }}
                        .form__field-body
                            cs-multiselect(
                                :options="seconds"
                                v-model='params.speed'
                                :custom-label="secondsLabel"
                                :placeholder="secondsLabel(params.speed)"
                                :multiple="false"
                                :allow-empty="false"
                                :hide-selected="true"
                            )
                    .form__field(v-if="slug === 'FlashCards'")
                        label.form__label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_gameDuration') }}
                        .form__field-body
                            cs-multiselect(
                                :options="durations"
                                v-model='params.duration'
                                :custom-label="minutesLabel"
                                :placeholder="minutesLabel(params.duration)"
                                :multiple="false"
                                :allow-empty="false"
                                :hide-selected="true"
                            )
                template(v-if="slug === 'InteractiveFlashCards'")
                    .form__field
                        label.form__label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_showInSeries', {element: $i18n.t('trainer.trainer_gameFormSettingValue_numbers')}) }}
                        .form__field-body
                            cs-checkbox(v-model='params.isSeries')
                    template(v-if='params.isSeries')
                        .form__field
                            label.form__label
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfSeries') }}
                            .form__field-body
                                cs-spin-input(
                                    :value="params.seriesAmount",
                                    :max="20",
                                    :min="1",
                                    @increase="params.seriesAmount++",
                                    @decrease="params.seriesAmount--",
                                    @input="params.seriesAmount = $event"
                                )
                        .form__field
                            label.form__label
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_numsInSeries') }}
                            .form__field-body
                                cs-spin-input(
                                    :value="params.seriesExamples",
                                    :max="9",
                                    :min="1",
                                    @increase="params.seriesExamples++",
                                    @decrease="params.seriesExamples--",
                                    @input="params.seriesExamples = $event"
                                )
                    .form__field(v-else='')
                        label.form__label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfNumbers') }}
                        .form__field-body.form__field-with-infinity-mode
                            cs-spin-input(
                                :value="params.amount",
                                :max="100",
                                :min="1",
                                @increase="!params.infinityAmountOfExamples && params.amount++",
                                @decrease="!params.infinityAmountOfExamples && params.amount--",
                                @input="params.amount = $event"
                                :disabled="params && params.infinityAmountOfExamples"
                            )
                            .form-container__select-infinity-mode(v-if="gameMode && gameMode === 'free-game'")
                                cs-checkbox#infinityAmount.form-container__checkbox(
                                    v-model="params.infinityAmountOfExamples"
                                    :checked="params && params.infinityAmountOfExamples"
                                )
                                svg-icon.form-container__svg-icon(name="infinity" :aria-hidden="true" size="big")
                divider
            .form__field.form__field--column
                label.form__label.form__label--left
                    | 0-9
                .form__field-body.form__field-body--inline
                    template(v-for='number in 9')
                        cs-checkbox.numbers-checkbox(
                            :checked='params.difficult.digits && !!params.difficult.digits[number - 1]',
                            @change="setDifficult('digits', number)"
                        )
                            | {{ number }}
            .form__field.form__field--column
                label.form__label
                .form__field-body
                    cs-checkbox(
                        :checked='params.difficult.tens',
                        @change="setDifficult('tens', true)"
                        :disabled="isDisabled('tens')"
                    )
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_tenners') }} 10-90
            .form__field.form__field--column
                label.form__label
                .form__field-body
                    cs-checkbox(
                        :checked='params.difficult.teens',
                        @change="setDifficult('teens', true)"
                        :disabled="isDisabled('teens')"
                    )
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_doubleDigits') }} 10-19
            .form__field.form__field--column
                label.form__label
                .form__field-body
                    cs-checkbox(
                        :checked='params.difficult.twoDigit',
                        @change="setDifficult('twoDigit', true)"
                        :disabled="isDisabled('twoDigit')"
                    )
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_doubleDigits') }} 10-99
            .form__field.form__field--column
                label.form__label
                .form__field-body
                    cs-checkbox(
                        :checked='params.difficult.hundreds',
                        @change="setDifficult('hundreds', true)"
                        :disabled="isDisabled('hundreds')"
                    )
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_tripleHundreds') }} 100-900
            .form__field.form__field--column
                label.form__label
                .form__field-body
                    cs-checkbox(
                        :checked='params.difficult.threeDigit',
                        @change="setDifficult('threeDigit', true)"
                        :disabled="isDisabled('threeDigit')"
                    )
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_tripleDigits') }} 100-999
            .form__field.form__field--column
                label.form__label
                .form__field-body
                    cs-checkbox(
                        :checked='params.difficult.thousands',
                        @change="setDifficult('thousands', true)"
                        :disabled="isDisabled('thousands')"
                    )
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_fourThousands') }} 1000-9000
            .form__field.form__field--column
                label.form__label
                .form__field-body
                    cs-checkbox(
                        :checked='params.difficult.fourDigit',
                        @change="setDifficult('fourDigit', true)"
                        :disabled="isDisabled('fourDigit')"
                    )
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_fourDigits') }} 1000-9999
            .form__field.form__field--column
                label.form__label
                .form__field-body
                    cs-checkbox(
                        :checked='params.difficult.fiveDigit',
                        @change="setDifficult('fiveDigit', true)"
                        :disabled="isDisabled('fiveDigit')"
                    )
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_fiveDigits') }} 10000-99999
            divider
            slot(name='parameters')
            slot(name='help')
            .form__buttons(v-if='!usersIds')
                cs-button.form__button(type="button" @click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                template(v-if="gameMode === 'free-game'")
                    cs-button.form__button(type="button" color="blue", @click='saveGameMode')
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                template(v-else='')
                    cs-button.form__button(type="button" color="blue", @click='saveGame')
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
            .form__buttons(v-else='')
                cs-button.form__button(type="button" @click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                cs-button.form__button(type="button" color="blue", @click='saveGame')
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}

</template>

<script>
    /*eslint-disable*/
    import TrainerGames from '../../../config/trainer';
    import FlashCardsConfig from '../../trainer/configs/FlashCardsConfig';
    import {mapState} from 'vuex';
    import _ from 'lodash';
    import GameFormMixin from '../../../utils/trainer/GameFormMixin';
    import multiplayerFormMixin from '../../../utils/multiplayer/formMixin'

    import {getInitParameters} from '../../../utils/trainer/getInitParameters'

    export default {
        data() {
            return {
                params: null,
                seconds: FlashCardsConfig.seconds,
                durations: FlashCardsConfig.durations,
                games: TrainerGames.games,
                digits: FlashCardsConfig.digits,
            };
        },
        mixins: [GameFormMixin, multiplayerFormMixin],
        props: [
            'gameMode',
            'slug',
            'courseType',
            'id',
            'usersIds',
            'homeworkId',
            'gameId',
            'generatorSettings',
            'generatorGameIndex'
        ],
        mounted() {
            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = _.cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.params = getInitParameters({
                        slug: this.slug,
                        parameters: {
                            default: this.gamesParameters[this.slug]
                        }
                    })
                } else {
                    _.cloneDeep(TrainerGames.games).forEach(item => {
                        if (item.slug === this.slug) {
                            this.params = item.parameters.default;
                        }
                    });
                }
                this.params.infinityAmountOfExamples = true;
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
        },
        watch: {
            'params.difficult.digits': {
                handler(val) {
                    if (val && val.length === 0) {
                        this.params.difficult.digits = null;
                    }
                }
            },
            'params.isSeries' (value, oldValue) {
                if (this.slug === 'InteractiveFlashCards' && oldValue !== undefined) {
                    this.params.infinityAmountOfExamples = false;
                }
            }
        },
        methods: {
            isDisabled (rule) {
//                return this.$store.state.auth.user.type !== 'student' ? false : !this.gamesParameters[this.slug].difficult[rule];
                return false
            },
            setDifficult(key, value) {
//                if (this.gameMode === 'course') {
//                    key === 'digits' ? this.params.difficult.digits = this.digits.slice(0, value) : this.params.difficult[key] = value;
//                    return;
//                }
                if (this.params.difficult[key] === value) {
                    this.params.difficult[key] = false;
                } else if (
                    this.params.difficult[key]
                    && this.params.difficult[key][this.params.difficult[key].length - 1] === value
                ) {
                    this.params.difficult[key] = this.params.difficult[key].slice(0, this.params.difficult[key].length - 1);
                } else {
                    Object.assign(this.params.difficult, {
                        teens: false,
                        twoDigit: false,
                        threeDigit: false,
                        fourDigit: false,
                        fiveDigit: false
                    });
                    if (key === 'digits') {
                        this.params.difficult.digits = this.digits.slice(0, value);
                    } else if (key !== 'tens' && key !== 'hundreds' && key !== 'thousands') {
                        this.params.difficult[key] = value;
                        this.params.difficult.digits = null;
                        this.params.difficult.tens = false;
                        this.params.difficult.hundreds = false;
                        this.params.difficult.thousands = false;
                    } else if (key === 'tens') {
                        this.params.difficult[key] = value;
                        this.params.difficult.hundreds = false;
                        this.params.difficult.thousands = false;
                    } else if (key === 'hundreds') {
                        this.params.difficult[key] = value;
                        this.params.difficult.tens = false;
                        this.params.difficult.thousands = false;
                    } else {
                        this.params.difficult[key] = value;
                        this.params.difficult.hundreds = false;
                        this.params.difficult.tens = false;
                    }
                }
            },
            secondsLabel (amount) {
                return amount + ' ' + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds');
            },
            minutesLabel (amount) {
                return amount + ' ' + this.$i18n.t('trainer.trainer_gameFormSettingValue_minutes');
            },
            possibleAmount () {
                return this.createArrayFromNumber(100);
            },
            createArrayFromNumber (number) {
                return Array.from(Array(number), (_, i) => i + 1);
            },
        },
        computed: {
            ...mapState({
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user
            })
        }
    }
</script>

<style lang="scss" scoped>
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        max-width: 1020px;
        margin: 0 auto;
        box-sizing: border-box;
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }

    .form__field--column {
        flex-direction: column;
        margin-bottom: 20px;
        align-items: flex-start;
    }

    .form__input {
        margin-bottom: 0;
    }

    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: .5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .form__label--left {
        min-width: 0;
        width: auto;
        margin-bottom: 20px;
    }

    .form__label--image {
        @include media($md) {
            padding-top: 2.5em;
        }
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__field-body--inline {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .form__field-body--bold {
        font-weight: 500;
    }

    .numbers-checkbox:not(:last-child) {
        margin-right: 10px;
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }

    .form-container__select {
        width: 100%;
        max-width: 300px;
        @media screen and (max-width: 767px) {
            max-width: none;
        }
    }

    .form__field-with-infinity-mode {
        display: flex;
    }

    .form-container__select-infinity-mode {
        display: flex;
        align-items: center;
        margin-top: 20px;
        @media screen and (min-width: 700px) {
            margin-top: 0;
        }
    }

    .form-container__checkbox{
        margin-left: 30px;
    }

    .form-container__svg-icon {
        opacity: 0.7;
        margin: 0 10px 10px 0;
    }
</style>
